import { useBuilderWidget } from 'components/TasksV2/TaskCreation/contexts/BuilderWidgetContext'
import { useCreationText } from 'components/TasksV2/TaskCreation/hooks/useCreationText'
// PollQuestion.tsx

import React, { memo } from 'react'
import { Flex, Text } from '@chakra-ui/core'
import { Controller, useFormContext } from 'react-hook-form'
import { ControlledCustomSwitch } from 'components/TasksV2/UI/ControlledCustomSwitch'
import { CustomTextareaAutosize } from 'components/helperStyles'
import useLocaleText from 'components/useLocaleText'
import { Subtask } from 'components/TasksV2/TaskCreation/FormStepContext'
import colors from 'constants/colors'

interface IProps {
  subtaskPath: string
  field: Subtask
  headerAction?: React.ReactNode
}

export const OpenQuestion: React.FC<IProps> = memo(({ subtaskPath, field, headerAction }) => {
  const builder = useBuilderWidget()
  const t = useCreationText()
  const { control } = useFormContext()
  const validationMessage = useLocaleText('open_question_st_error')
  const t_is_numeric = useLocaleText('is_numeric')
  const t_questionLabel = useLocaleText('t_questionLabel')

  const questionName = `${subtaskPath}.title`

  return (
    <Flex className={builder ? 'creation-question-section' : undefined} direction="column" my={builder ? '0' : '20px'}>
      <Flex
        className={builder ? 'creation-answer-heading' : undefined}
        alignItems="center"
        justifyContent="space-between"
      >
        {builder ? (
          <label htmlFor={questionName}>
            {t.questionLabel} <span className="creation-required-star">*</span>
          </label>
        ) : (
          <Text px="15px" fontSize="14px">
            {t_questionLabel}
          </Text>
        )}
        {headerAction}
        {!builder && (
          <Flex alignItems="center" style={{ columnGap: '10px' }} mb="5px">
            <Text fontSize="12px" color={colors.analyticGrey}>
              {t_is_numeric}
            </Text>
            <Controller
              as={ControlledCustomSwitch}
              name={`${subtaskPath}.is_numeric`}
              control={control}
              defaultValue={false}
              valueName="isChecked"
              onChange={([event]) => {
                return event.target.checked
              }}
            />
          </Flex>
        )}
      </Flex>
      <Controller
        as={CustomTextareaAutosize}
        name={questionName}
        id={questionName}
        control={control}
        placeholder={t_questionLabel}
        defaultValue={field.title ?? ''}
        rules={{
          required: validationMessage,
          maxLength: { value: 250, message: validationMessage },
          validate: (value) => {
            return value.trim() !== '' || validationMessage
          },
        }}
        key={questionName}
        maxLength={250}
        minHeight="80px"
        boxShadow="none"
        style={{ border: '2px solid #f0f0f0', borderRadius: '10px', paddingLeft: '10px', paddingRight: '10px' }}
      />
    </Flex>
  )
})
